<template>
  <div class="tw-flex tw-flex-col tw-gap-y-6 tw-p-8 tw-w-full tw-border tw-border-neutral-300 tw-rounded-xl tw-bg-white tw-relative">
    <slot />
  </div>
</template>
